module.exports = __webpack_public_path__ + "img/length.a55a9339.png";